import { ParagraphSkeletonLoading, TextLinkButton, styleVariables } from '@lib/common';
import styled from 'styled-components';
import { AddMoreSectionPopoverComponent } from './add-more-section-popover.component';
import { ExclamationCircleFilled, MoreOutlined } from '@ant-design/icons';
import { Popover } from 'antd';
import { QuestionSummaryComponent } from './question-summary.component';
import { getSize } from '@xstyled/styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var Layout = styled.div.withConfig({
  displayName: "section-summarycomponent__Layout",
  componentId: "sc-jrob9p-0"
})(["display:flex;flex-direction:column;height:inherit;"]);
var StyledSectionSummaryWrapper = styled.div.withConfig({
  displayName: "section-summarycomponent__StyledSectionSummaryWrapper",
  componentId: "sc-jrob9p-1"
})(["overflow-y:scroll;height:auto;max-height:68vh;::-webkit-scrollbar{width:3px;}::-webkit-scrollbar-thumb{border-radius:10px;background-color:", ";}@supports (overflow:overlay){overflow:overlay;}"], styleVariables.colors.gray8);
var StyledEndLineScore = styled.div.withConfig({
  displayName: "section-summarycomponent__StyledEndLineScore",
  componentId: "sc-jrob9p-2"
})(["white-space:nowrap;cursor:pointer;margin-top:auto;font-size:15px;padding:12px 24px;transition:all 0.2s ease;display:flex;align-items:center;justify-content:space-between;font-weight:600;"]);
var StyledEndLineTittle = styled.span.withConfig({
  displayName: "section-summarycomponent__StyledEndLineTittle",
  componentId: "sc-jrob9p-3"
})(["white-space:nowrap;overflow:hidden;text-overflow:ellipsis;cursor:pointer;span{font-size:12px;opacity:50%;}"]);
var StyledPanelSection = styled.div.withConfig({
  displayName: "section-summarycomponent__StyledPanelSection",
  componentId: "sc-jrob9p-4"
})(["position:relative;height:52px;display:flex;align-items:center;justify-content:space-between;border-bottom:1px solid ", ";box-shadow:inset 0 0 0 1px transparent;font-size:15px;width:100%;transition:all 0.2s ease;font-weight:600;color:", ";background-color:", ";&.active{background-color:", ";font-size:14px;color:", ";}&:hover{color:", ";background-color:", ";}cursor:pointer;"], styleVariables.colors.gray3, function (_ref) {
  var $active = _ref.$active;
  return $active ? styleVariables.colors.colorPrimaryBase : styleVariables.colors.gray11;
}, function (_ref2) {
  var $active = _ref2.$active;
  return $active ? styleVariables.colors.gray8 : 'transparent';
}, styleVariables.colors.gray8, styleVariables.colors.colorPrimaryBase, styleVariables.colors.colorPrimaryBase, styleVariables.colors.gray6);
var StyledPanelQuestion = styled.div.withConfig({
  displayName: "section-summarycomponent__StyledPanelQuestion",
  componentId: "sc-jrob9p-5"
})(["display:", ";position:absolute;"], function (_ref3) {
  var $active = _ref3.$active;
  return $active ? 'contents' : 'none';
});
var StyledPanelSectionTitle = styled.span.withConfig({
  displayName: "section-summarycomponent__StyledPanelSectionTitle",
  componentId: "sc-jrob9p-6"
})(["display:flex;justify-content:space-between;align-items:center;padding:16px 0px 16px 8px;p{margin-bottom:0px;}"]);
var KebabButton = styled(TextLinkButton).withConfig({
  displayName: "section-summarycomponent__KebabButton",
  componentId: "sc-jrob9p-7"
})(["width:10px !important;background:'green' !important;"]);
var StyledPanelSectionScore = styled(StyledPanelSectionTitle).withConfig({
  displayName: "section-summarycomponent__StyledPanelSectionScore",
  componentId: "sc-jrob9p-8"
})(["white-space:normal;overflow:visible;text-overflow:clip;"]);
var StyledExclamationCircleFilled = styled(ExclamationCircleFilled).withConfig({
  displayName: "section-summarycomponent__StyledExclamationCircleFilled",
  componentId: "sc-jrob9p-9"
})(["color:", ";margin-right:10px;"], styleVariables.colors.gold1);
var StyledSummaryContainer = styled(Layout).withConfig({
  displayName: "section-summarycomponent__StyledSummaryContainer",
  componentId: "sc-jrob9p-10"
})(["padding:", ";"], getSize('padding8'));
export var warningPopover = function warningPopover(title) {
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(StyledExclamationCircleFilled, {}), /*#__PURE__*/_jsx("span", {
      children: title
    })]
  });
};
export var SectionSummaryPanelComponent = function SectionSummaryPanelComponent(_ref4) {
  var selectedFormItemId = _ref4.selectedFormItemId,
      sectionSummaries = _ref4.sectionSummaries,
      questions = _ref4.questions,
      onCreateSection = _ref4.onCreateSection,
      onCreateQuestion = _ref4.onCreateQuestion,
      hasUnsavedQuestionOrSectionChanges = _ref4.hasUnsavedQuestionOrSectionChanges,
      onSelectQuestion = _ref4.onSelectQuestion,
      onSelectedSection = _ref4.onSelectedSection,
      sectionFocusedId = _ref4.sectionFocusedId,
      labelTranslation = _ref4.labelTranslation;
  var totalQuestionScore = sectionSummaries === null || sectionSummaries === void 0 ? void 0 : sectionSummaries.reduce(function (partialSum, q) {
    return partialSum + q.totalScore;
  }, 0);

  var renderSectionSummaries = function renderSectionSummaries() {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: sectionSummaries === null || sectionSummaries === void 0 ? void 0 : sectionSummaries.map(function (section, sectionIndex) {
        var id = section.id;
        var sectionId = id.toString();
        var questionsBySectionId = questions.filter(function (q) {
          return q.sectionId === sectionId;
        });
        return /*#__PURE__*/_jsxs("div", {
          id: sectionId + '-panel',
          children: [!hasUnsavedQuestionOrSectionChanges ? /*#__PURE__*/_jsxs(StyledPanelSection, {
            $active: selectedFormItemId === sectionId,
            onClick: function onClick() {
              return onSelectedSection(sectionId);
            },
            children: [/*#__PURE__*/_jsxs(StyledPanelSectionTitle, {
              children: [labelTranslation.section, " ", sectionIndex + 1, ". ", section.title]
            }), /*#__PURE__*/_jsxs(StyledPanelSectionScore, {
              children: [section.totalScore === 0 ? '-' : section.totalScore, /*#__PURE__*/_jsx(AddMoreSectionPopoverComponent, {
                section: section,
                onCreateSection: onCreateSection,
                labelTranslation: labelTranslation
              })]
            })]
          }) : /*#__PURE__*/_jsx(Popover, {
            title: "",
            content: warningPopover(labelTranslation.questionChangingWarning),
            trigger: 'hover',
            children: /*#__PURE__*/_jsxs(StyledPanelSection, {
              $active: selectedFormItemId === sectionId,
              children: [/*#__PURE__*/_jsxs(StyledPanelSectionTitle, {
                children: [labelTranslation.section, " ", sectionIndex + 1, ". ", section.title]
              }), /*#__PURE__*/_jsxs(StyledPanelSectionScore, {
                children: [section.totalScore === 0 ? '-' : section.totalScore, /*#__PURE__*/_jsx(KebabButton, {
                  size: "large",
                  icon: /*#__PURE__*/_jsx(MoreOutlined, {}),
                  type: "text",
                  shape: "circle",
                  onClick: function onClick(e) {
                    e.stopPropagation();
                  }
                })]
              })]
            })
          }), /*#__PURE__*/_jsx(StyledPanelQuestion, {
            $active: sectionFocusedId === sectionId,
            children: /*#__PURE__*/_jsx(QuestionSummaryComponent, {
              questions: questionsBySectionId,
              onCreateQuestion: onCreateQuestion,
              hasUnsavedQuestionOrSectionChanges: hasUnsavedQuestionOrSectionChanges,
              onSelectQuestion: onSelectQuestion,
              labelTranslation: labelTranslation,
              selectedFormItemId: selectedFormItemId
            })
          })]
        }, sectionId);
      })
    });
  };

  return /*#__PURE__*/_jsxs(StyledSummaryContainer, {
    children: [sectionSummaries ? /*#__PURE__*/_jsx(StyledSectionSummaryWrapper, {
      children: renderSectionSummaries()
    }) : /*#__PURE__*/_jsx(ParagraphSkeletonLoading, {}), /*#__PURE__*/_jsxs(StyledEndLineScore, {
      children: [/*#__PURE__*/_jsx(StyledEndLineTittle, {
        children: labelTranslation.totalScore
      }), /*#__PURE__*/_jsx(StyledEndLineTittle, {
        children: totalQuestionScore
      })]
    })]
  });
};